import React from "react";
import { loadingText } from "./constants";
import { pushPreflightToast } from 'utils/preFlightToast';
import messages from "../messages";
import { dispatch } from 'pluginServices/store';
import { removeToast } from 'containers/ToastManager/actions';

export const CSVFetchExportLink = ({ fetchCSVData, fileName, isLoading, setIsLoading, activityId, title, children }) => {
  const handleDownload = async () => {
    let cancelDownload = false;
    pushPreflightToast(messages.generateSBMediaGrid, title, activityId, 0, () => { cancelDownload = true; });

    setIsLoading(true);
    const data = await fetchCSVData();

    if (!data || data.length === 0 || cancelDownload) {
      setIsLoading(false);
      //remove the toast if the data fetch was unsuccessful
      dispatch(removeToast({ toastId: activityId }));
      return;
    }
    // Convert the data array to CSV format
    const csvContent = arrayToCSV(data);
    // Create a new anchor element
    const link = document.createElement('a');
    // Create a blob URL for the CSV content and set it as the href attribute of the link
    link.href = URL.createObjectURL(new Blob([csvContent], { type: 'text/csv;charset=utf-8;' }));
    // Set the download attribute with the desired file name
    link.setAttribute('download', fileName);
    // Append the link to the document body and trigger a click to start the download
    document.body.appendChild(link).click();
    // Remove the link from the document body
    document.body.removeChild(link);

    dispatch(removeToast({ toastId: activityId }));
    setIsLoading(false);
  };

  // This function converts an array of data to a CSV formatted string
  const arrayToCSV = (data) => (
    data.map((row) => row.join(",")).join("\n")
  );

  return (
    <div>
      {isLoading ? (
        <span>{loadingText}</span>
      ) : (
        <span onClick={handleDownload}>{children}</span>
      )}
    </div>
  );
};